import { Flex, FlexProps, Text, Tooltip } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

interface StepperProps extends FlexProps {
  steps: Steps[];
  currentStep: string | number;
  color: string;
}

interface Steps {
  key: string | number;
  title: string | number;
}

const JobStepper = ({
  steps,
  currentStep,
  color,
  alignItems: _,
  ...flexProps
}: StepperProps): JSX.Element => {
  const currentStepIndex = steps.findIndex((s) => s.key === currentStep);
  const nextStepIndex = currentStepIndex + 1;
  const stepWidth = 100 / steps.length;
  return (
    <>
      <Flex width="100%" alignItems="flex-start" {...flexProps}>
        {steps.map((step, index) => {
          const completed = currentStepIndex > index;
          const selected = currentStepIndex === index;
          const firstStep = index === 0;
          const lastStep = steps.length === index + 1;

          return (
            <Flex
              key={step.key}
              position="relative"
              direction="column"
              alignItems="center"
              justifyContent="center"
              width={`${stepWidth}%`}
            >
              {!firstStep && (
                <Flex
                  position="absolute"
                  top="8px"
                  left="0px"
                  width={'calc(50% - 8px)'}
                  height={0}
                  borderTopWidth="1px"
                  borderTopStyle="solid"
                  borderTopColor={
                    completed || selected ? color : 'custom.levoLightGray'
                  }
                />
              )}
              <Tooltip
                hasArrow
                label={step.title}
                aria-label="Step Label"
                borderRadius="4px"
                bg="white"
                color="custom.levoBlue"
                boxShadow="0 4px 12px rgb(0 0 0 / 20%)"
                fontWeight={600}
                placement="top"
              >
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  boxSize={4}
                  borderWidth="2px"
                  borderColor={
                    selected || completed ? color : 'custom.levoLightGray'
                  }
                  borderRadius={50}
                  bg={completed ? color : 'transparent'}
                >
                  {completed && <CheckIcon boxSize={2} color="white" />}
                </Flex>
              </Tooltip>
              {!lastStep && (
                <Flex
                  position="absolute"
                  top="8px"
                  right="0px"
                  width={'calc(50% - 8px)'}
                  height={0}
                  borderTopWidth="1px"
                  borderTopStyle="solid"
                  borderTopColor={completed ? color : 'custom.levoLightGray'}
                />
              )}
            </Flex>
          );
        })}
      </Flex>
      <Flex direction="column" width="100%" alignItems="center" mt={3}>
        <Text textStyle="notification" color="custom.levoBlue">
          {currentStepIndex > -1
            ? steps[currentStepIndex].title
            : 'Getting Prepped'}
        </Text>
        {!!steps[nextStepIndex] && (
          <Text textStyle="preTitle" fontWeight={400} mt={0.5}>
            Next: {steps[nextStepIndex].title}
          </Text>
        )}
      </Flex>
    </>
  );
};

export default JobStepper;
